export default __webpack_public_path__ + "static/SoftwareDevelopment-4ff52a3311061b610b5cfb58d8ba0e09.png";